import React from "react";
import styled from "styled-components";
import Container from "src/react/layout/container";
import { color } from "src/styles/variables";

function WhyCornerstone() {
  return (
    <Wrapper>
      <Container>
        <Steps />
      </Container>
    </Wrapper>
  );
}

export default WhyCornerstone;

const Wrapper = styled.div`
  padding: 30px 0;
  text-align: center;
  background-color: ${color.lightGrey};
`;

const reasons = [
  {
    title: `Build your basket`,
    description: `Select a combination of our award-winning shaving products, bathroom and healthcare supplies.
    `,
  },
  {
    title: `Subscription or One-off?`,
    description: `Choose to subscribe for regular deliveries to match your personal routine, or order without a subscription.
    `,
  },
  {
    title: `Enjoy flexibility`,
    description: `As a subscribed member you can change, delay or cancel your plan at any time. No contracts, no commitments.
    `,
  },
];

function Steps() {
  return (
    <Reasons>
      {reasons.map((reason, index) => (
        <Reason key={index} column>
          <Subtitle step={index + 1}>{reason.title}</Subtitle>
          <Description>{reason.description}</Description>
        </Reason>
      ))}
    </Reasons>
  );
}

const Reasons = styled.div`
  @media (min-width: 700px) {
    display: flex;
  }
`;

const Reason = styled.div`
  margin: 10px auto 30px;
  max-width: 400px;
  color: ${color.grey};
  @media (min-width: 700px) {
    flex-basis: 100%;
    margin-right: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
  }
`;

const Description = styled.p`
  margin-bottom: 10px;
`;

const Subtitle = styled.h3`
  font-size: 20px;
  line-height: 1.25em;
  font-weight: 600;
  position: relative;
  margin-bottom: 10px;
  :before {
    content: "${({ step }) => step}";
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    padding: 10px;
    color: ${color.red};
    border: 3px solid ${color.red};
    border-radius: 50%;
    width: 50px;
    height: 50px;
    margin: 0 auto 10px;
  }
`;
